
import React, { useRef } from 'react'
import UploadInput from '../formComponents/uploadInput'
import { useCarromm } from '../../context/carrom';

const UploadModal = () => {
  const carrom = useCarromm()
  const ref = useRef();

  return (
    <div className={`upload-modal ${carrom?.isButtonDisabled ? "pointer-events-none opacity-[0.5]" : ""}`}>
      <div className="upload-modal-body">
        <UploadInput ref={ref} />
      </div>
    </div>
  )
}

export default UploadModal